/**
 * The storage module's routes, owned by the feature. D5.
 *
 * The accounts list (BO1) and detail (`storage/:id`, BO2), plus NEX-1171's supervision of storage
 * requests (`storage/requests`, `storage/requests/:id`, read-only) and the administrable catalog
 * (`storage/catalog`), and NEX-1169's payouts to the depósitos (`storage/payouts`, plan 2026-10-20
 * task 1.10). One sidebar entry ("Depósitos") covers all of them: the four list screens
 * are tabs of one section (`components/StorageSectionNav.tsx`), and the two details are reached
 * from their list's own rows, same as `drivers/:id`. React Router ranks static segments over
 * `:id`, so `storage/requests` never reads as an account id; the static paths are listed first
 * anyway, so the table reads in the order it matches.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const StoragePage = lazy(() => import('./StoragePage'));
const StorageProfile = lazy(() => import('./StorageProfile'));
const StorageRequestsPage = lazy(() => import('./StorageRequestsPage'));
const StorageRequestDetail = lazy(() => import('./StorageRequestDetail'));
const StorageCatalogPage = lazy(() => import('./StorageCatalogPage'));
const StoragePayoutsPage = lazy(() => import('./StoragePayoutsPage'));

export const storageRoutes: RouteObject[] = [
    { path: 'storage', element: <StoragePage /> },
    { path: 'storage/requests', element: <StorageRequestsPage /> },
    { path: 'storage/requests/:id', element: <StorageRequestDetail /> },
    { path: 'storage/catalog', element: <StorageCatalogPage /> },
    { path: 'storage/payouts', element: <StoragePayoutsPage /> },
    { path: 'storage/:id', element: <StorageProfile /> },
];
